module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@2x-fa8c6e4cafdd453929d87ffa4fba39a7.webp";